module.exports = __webpack_public_path__ + "static/media/fj.3e230d8e.svg";